export enum RequestStatusEnum {
    Created = 1,
    Rejected = 2,
    Approved = 3,
    Aborted = 4,
}

export const REQUEST_STATUS = [
    { value: RequestStatusEnum.Created, label: 'Creado' },
    { value: RequestStatusEnum.Rejected, label: 'Rechazado' },
    { value: RequestStatusEnum.Approved, label: 'Aprobado' },
    { value: RequestStatusEnum.Aborted, label: 'Abandonado' },
];
